import { Injectable } from '@angular/core';
import { AgregarInteresesModalComponent } from '../../paginas/acuerdos-pago/agregar-intereses-modal/agregar-intereses-modal.component';
import { ContinteresesService } from '../../services/intereses/cont_intereses.service';
import { DataService } from '../../util/data.service';
import { AgregarInteresesModalAcuerdoComponent } from 'src/app/paginas/acuerdos-pago/agregar-intereses-modal-acuerdo/agregar-intereses-modal-acuerdo.component';

@Injectable({
  providedIn: 'root',
})
export class interesesController {
  constructor(
    private _interesesService: ContinteresesService,
    private _serviceDataService: DataService,
  ) {}

  agregarInteres(view: AgregarInteresesModalComponent): void {
    const currentUser = this._serviceDataService.getCurrentUser();
    const compId = view.data.compId;

    const idUser =
      currentUser?.usuario?.ID ||
      currentUser?.usuario?.usuaId ||
      currentUser?.usuaId ||
      1;

    if (!idUser) {
      console.error(
        'No se pudo obtener el ID del usuario. currentUser:',
        currentUser,
      );
      return;
    }

    const valor = view.interestsForm.get('interestAmount')?.value;

    this._interesesService.asignarIntereses(compId, idUser, valor).subscribe({
      next: (response) => {
        view._serviceMensajes.showMessage(response.severity, response.msg);
        console.log('Intereses asignados correctamente:', response);

        view.dialogRef.close({
          guardado: true,
          valorInteres: response?.intereses ?? valor,
          mensaje: response?.msg ?? 'Intereses asignados correctamente',
        });
      },
      error: (err) => {
        console.error('Error al asignar intereses:', err);
      },
    });
  }

  agregarInteresAcuerdo(view: AgregarInteresesModalAcuerdoComponent) {
    const currentUser = this._serviceDataService.getCurrentUser();
    const compId = view.data.compId;

    const idUser =
      currentUser?.usuario?.ID ||
      currentUser?.usuario?.usuaId ||
      currentUser?.usuaId ||
      1;

    if (!idUser) {
      console.error(
        'No se pudo obtener el ID del usuario. currentUser:',
        currentUser,
      );
      return;
    }

    const valor = view.interestsForm.get('interestAmount')?.value;

    this._interesesService
      .asignarInteresesNormales(compId, idUser, valor)
      .subscribe({
        next: (response) => {
          view._serviceMensajes.showMessage(response.severity, response.msg);
          console.log('Intereses asignados correctamente:', response);

          view.dialogRef.close({
            guardado: true,
            valorInteres: response?.intereses ?? valor,
            mensaje: response?.msg ?? 'Intereses asignados correctamente',
          });
        },
        error: (err) => {
          console.error('Error al asignar intereses:', err);
        },
      });
  }
}
